import { TRANSLATION } from '@/imports-files/common/common';
export const INTERVIEW_TYPES = {
    PHONE:   'Phone',
    VIDEO:   'Video',
    VIDEOQA: 'Video Q&A',
    TECHTEST:  'Assessment',
    FACE2FACE: 'In-Person',
    primaryColor: '#dd564d',
 }

 export const INTERVIEW_TYPE_HEADERS = (t) => ({
  PHONE: {
    header: t('modal:automation:interview:phone:heading'),
    subheader: t('modal:automation:interview:phone:subheading')
  },
  VIDEO: {
    header: t('modal:automation:interview:video:heading'),
    subheader: t('modal:automation:interview:video:subheading')
  },
  VIDEOQA: {
    header: t('modal:automation:interview:video_qa:heading'),
    subheader: t('modal:automation:interview:video_qa:subheading')
  },
  TECHTEST: {
    header: t('modal:automation:interview:techtest:heading'),
    subheader: t('modal:automation:interview:techtest:subheading')
  },
  FACE2FACE: {
    header: t('modal:automation:interview:face2face:heading'),
    subheader: t('modal:automation:interview:face2face:subheading')
  },
  DEFAULT: {
    header: t('modal:automation:interview:default:heading'),
    subheader: t('modal:automation:interview:default:subheading')
  }
});
